export default "__VITE_ASSET__10667e1d__"